import React from 'react';
import Container from '@material-ui/core/Container';
import css from './login.css';

class Logout extends React.Component {
  render() {
    return (
      <div className="container">
        <Container className={css.background} component="main" maxWidth="xs">
          <div className={[css.paper, css.logoutInfo].join(' ')}>
            You have been logged out, thanks for using Bank data.
          </div>
        </Container>
      </div>
    );
  }
}

export default Logout;



// WEBPACK FOOTER //
// ./src/components/Portal/Logout.js